import { message } from 'antd';

import { CustomerAPI, IAssetPasswordReq } from '@api/index';
import { I18n } from '@utils/index';

import { IDataRef } from './type';

interface IParams {
  dataRef: IDataRef;
  store: any;
  cb: () => void;
}

export const useSetAssetPassword = (params: IParams) => {
  const { dataRef, store, cb } = params;
  const setAssetPassword = async () => {
    const res = await CustomerAPI.assetPassword(dataRef.current as IAssetPasswordReq);
    if (!res.success) {
      message.error(I18n.t(res.msgKey))
      return
    }
    store.userStore.updateUserInfor({ isExistAssetPassword: true });

    cb()
  }
  return {
    setAssetPassword
  }
}
